import { post } from './http'

//获取班级信息
export function getClassInfo(date) {
  return post('/tyapi/pc/HeartRateCockpit/getClassInfo', {
    date: date,
  })
}

//学生实时心率
export function stuRealTimeHeartRate(classId, date, type) {
  return post('/tyapi/pc/HeartRateCockpit/stuRealTimeHeartRate', {
    classId: classId,
    date: date,
    type: type,
  })
}

//获取心率类型列表
export function getHeartRateTypeList() {
  return post('/tyapi/pc/HeartRateCockpit/getHeartRateTypeList', {})
}
